const generateShareList = (entity, schema, category, gameModel) => {
  const shareList = {};
  const components = gameModel.getComponentIdsByCategory(entity, category);
  if (!gameModel.hasComponent(entity, schema)) {
    return components.map((component) => [component, [entity]]);
  }
  components.forEach((component) => {
    if (!shareList[component]) {
      shareList[component] = [];
    }
    shareList[component].push(entity);
  });
  const data = gameModel.getComponentUnsafe(entity, schema);
  if (data.entities) {
    for (let i = 0; i < data.entities.length; i++) {
      const entity2 = data.entities[i];
      const components2 = gameModel.getComponentIdsByCategory(entity2, category);
      components2.forEach((component) => {
        if (!shareList[component]) {
          shareList[component] = [];
        }
        shareList[component].push(entity2);
      });
    }
  }
  return Object.entries(shareList).reduce((acc, [key, value]) => {
    acc.push([parseInt(key), value]);
    return acc;
  }, []).sort((a, b) => {
    const aDepth = gameModel.getDepth(a[0]);
    const bDepth = gameModel.getDepth(b[0]);
    return aDepth - bDepth;
  });
};
export {
  generateShareList
};
//# sourceMappingURL=generateShareList.js.map
